import * as React from "react";
import { forwardRef } from "react";
const SvgFlagDe = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 32, height: 8, y: 0, fill: "#000000" }), /* @__PURE__ */ React.createElement("rect", { width: 32, height: 8, y: 8, fill: "#DD0000" }), /* @__PURE__ */ React.createElement("rect", { width: 32, height: 8, y: 16, fill: "#FFCE00" }));
const ForwardRef = forwardRef(SvgFlagDe);
export default ForwardRef;
